import { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { MDBRow, MDBCol, MDBBtn } from "mdb-react-ui-kit";
import ReactJson from "react18-json-view";
import Select from "react-select";

class DeviceTwin extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      selectedOption: { value: "all", label: "All" },
      selectfinaldata: "all",
      AllJson: this.props.vehicleUploadData,
    };
  }

  volumehandleChange = (selectedOption: any) => {
    this.setState({
      selectedOption,
      selectfinaldata: selectedOption.value,
    });
  };

  submitjsonHandler = () => {
    console.log("Final Data ", this.state.AllJson);
    this.props.reversefunction(this.state.AllJson);
  };
  handleJsonEdit = (key: string, e: any) => {
    const updated = e.updated_src;
    let allJSON = { ...this.state.AllJson };

    if (key === "all") {
      allJSON = updated;
    } else {
      allJSON[key] = updated;
    }

    this.setState({ AllJson: allJSON });
  };

  render() {
    const options = [
      { value: "all", label: "All" },
      { value: "door", label: "Door" },
      { value: "engine", label: "Engine" },
      { value: "health", label: "Health" },
      { value: "cabin", label: "Cabin" },
      { value: "seatRemainder", label: "Seat Remainder" },
      { value: "extendedOpenings", label: "Extended Openings" },
      { value: "windows", label: "Windows" },
      { value: "alerts", label: "Alerts" },
      { value: "lamps", label: "Lamps" },
      { value: "seat", label: "Seat" },
      { value: "plug", label: "Plug" },
      { value: "charge", label: "Charge" },
      { value: "solar", label: "Solar" },
      { value: "climateControl", label: "Climate Control" },
    ];

    const { selectfinaldata } = this.state;

    const jsonSrc =
      selectfinaldata === "all"
        ? this.props.vehicleUploadData
        : this.props.vehicleUploadData?.[selectfinaldata];

    const key = selectfinaldata;

    return (
      <Row>
        <Col>
          <MDBRow>
            <MDBCol size="6">
              <div className="form-group">
                <label htmlFor="formFeatureInput">Feature</label>
                <Select
                  value={this.state.selectedOption}
                  onChange={this.volumehandleChange}
                  options={options}
                />
              </div>
            </MDBCol>

            <MDBCol size="12">
              <div className="JsonContent">
                {jsonSrc && (
                  <ReactJson
                    src={jsonSrc}
                    enableClipboard={false}
                    collapsed={true}
                    collapseStringsAfterLength={99}
                    displayArrayIndex={true}
                  />
                )}
              </div>
            </MDBCol>

            <MDBCol>
              <MDBBtn
                color="primary"
                className="float-right"
                onClick={this.submitjsonHandler}
              >
                Ok
              </MDBBtn>
              <MDBBtn
                color="light"
                className="text-dark float-right"
                onClick={this.props.toggle}
              >
                Close
              </MDBBtn>
            </MDBCol>
          </MDBRow>
        </Col>
      </Row>
    );
  }
}

export default DeviceTwin;
